<template>
    <div class="error">
        <div class="main">
            <img src="../static/img/404.png" alt="">
            <p>页面迷失在太空中......</p>
        </div>
    </div>
</template>

<script>
export default {

};
</script>

<style lang='less' scoped>
.error{
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #fff;
    .main{
        font-size: 14px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        img{
            height: 0.9rem;
            margin-bottom: 0.27rem;
        }
    }

}
</style>
